/* Native Shopify drawer, shared by the custom header and the editable PDP. */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const triggers = '[data-moviwi-cart-trigger]';
  const updateHeader = () => {
    const count = document.querySelector('#cart-icon-bubble [data-moviwi-cart-count]');
    document.querySelectorAll(triggers).forEach(trigger => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'CartDrawer');
      trigger.setAttribute('aria-expanded', String(drawer.classList.contains('active')));
    });
    if (!count) return;
    const label = count.dataset.cartLabel;
    if (label) document.querySelector('.site-cart')?.setAttribute('aria-label', label);
    document.querySelectorAll('[data-moviwi-mobile-count]').forEach(node => {
      node.textContent = `(${count.dataset.moviwiCartCount})`;
    });
  };
  new MutationObserver(updateHeader).observe(drawer, {attributes: true, attributeFilter: ['class']});
  const header = document.querySelector('#cart-icon-bubble');
  if (header) new MutationObserver(updateHeader).observe(header, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', updateHeader);
  updateHeader();

  document.addEventListener('click', event => {
    const trigger = event.target.closest(triggers);
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof drawer.open !== 'function') return;
    event.preventDefault();
    const menu = trigger.closest('.site-mobile-menu');
    // A mobile-menu link becomes hidden on activation; restore focus to its menu toggle.
    const returnTo = menu ? document.querySelector('.site-menu-toggle') : trigger;
    drawer.open(returnTo);
  });

  document.addEventListener('keydown', event => {
    if (event.defaultPrevented || event.code !== 'Space' || !event.target.matches(triggers)) return;
    event.preventDefault();
    event.target.click();
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-moviwi-cart-continue]')) return;
    event.preventDefault();
    drawer.close();
  });

  // Native product-form already handles standard product sections. Only enhance this PDP.
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.pdp-purchase-form') || event.defaultPrevented) return;
    if (typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const section = form.closest('[data-pdp-section]');
    if (section?.dataset.pdpCanBuy !== 'true' || event.submitter?.disabled || pending.has(form)) return;
    pending.add(form);
    const buttons = [...document.querySelectorAll('button')].filter(button => button.form === form);
    const states = buttons.map(button => button.disabled);
    const error = form.querySelector('[data-pdp-cart-error]');
    if (error) { error.textContent = ''; error.hidden = true; }
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const active = event.submitter || document.activeElement;
    drawer.setActiveElement(active);
    let added = false;
    try {
      const body = new FormData(form);
      const sections = drawer.getSectionsToRender().map(section => section.id);
      body.set('sections', sections.join(','));
      body.set('sections_url', location.pathname);
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST', body, credentials: 'same-origin',
        headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || window.cartStrings.error);
      added = true;
      // Retry only the section read if Shopify accepted the item but omitted section HTML.
      if (sections.some(id => !result.sections?.[id])) {
        const refresh = await fetch(`${window.routes.cart_url}?sections=${sections.join(',')}`, {credentials: 'same-origin'});
        if (!refresh.ok) throw new Error(window.cartStrings.error);
        result.sections = await refresh.json();
        if (sections.some(id => !result.sections[id])) throw new Error(window.cartStrings.error);
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'moviwi-product-form', cartData: result});
    } catch (failure) {
      if (error) {
        error.textContent = added ? error.dataset.refreshError : (failure.message || window.cartStrings.error);
        error.hidden = false;
      }
    } finally {
      pending.delete(form);
      form.removeAttribute('aria-busy');
      buttons.forEach((button, i) => { button.disabled = states[i]; button.removeAttribute('aria-busy'); });
    }
  });
})();
